import { Navbar } from '../bordeaux/components/Navbar';
import { Hero } from '../bordeaux/components/Hero';
import { Services } from '../bordeaux/components/Services';
import { BayWindows } from '../bordeaux/components/BayWindows';
import { WhatsAppDiagnostic } from '../bordeaux/components/WhatsAppDiagnostic';
import { Contact } from '../bordeaux/components/Contact';
import { Footer } from '../bordeaux/components/Footer';
import { useEffect } from 'react';

export default function SaintMedardJalles() {
  useEffect(() => {
    document.title = "Réparation Fenêtres Saint-Médard-en-Jalles | PVC Alu Bois | Baies Vitrées";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Expert en réparation de fenêtres à Saint-Médard-en-Jalles ✓ PVC, Aluminium, Bois ✓ Baies vitrées toutes marques ✓ Intervention rapide ✓ Devis gratuit');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'réparation fenêtres Saint-Médard-en-Jalles, fenêtres PVC Saint-Médard, baies vitrées Saint-Médard, vitrier Saint-Médard-en-Jalles');
    }

    const metaGeoPosition = document.querySelector('meta[name="geo.position"]');
    if (metaGeoPosition) {
      metaGeoPosition.setAttribute('content', '44.8947;-0.7189');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'geo.position';
      meta.content = '44.8947;-0.7189';
      document.head.appendChild(meta);
    }

    const metaGeoPlacename = document.querySelector('meta[name="geo.placename"]');
    if (metaGeoPlacename) {
      metaGeoPlacename.setAttribute('content', 'Saint-Médard-en-Jalles, Gironde, France');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'geo.placename';
      meta.content = 'Saint-Médard-en-Jalles, Gironde, France';
      document.head.appendChild(meta);
    }

    const metaGeoRegion = document.querySelector('meta[name="geo.region"]');
    if (metaGeoRegion) {
      metaGeoRegion.setAttribute('content', 'FR-33');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'geo.region';
      meta.content = 'FR-33';
      document.head.appendChild(meta);
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar city="Saint-Médard-en-Jalles" />
      <Hero city="Saint-Médard-en-Jalles" />
      <Services city="Saint-Médard-en-Jalles" />
      <BayWindows city="Saint-Médard-en-Jalles" />
      <WhatsAppDiagnostic city="Saint-Médard-en-Jalles" />
      <Contact city="Saint-Médard-en-Jalles" />
      <Footer city="Saint-Médard-en-Jalles" />
    </div>
  );
}